import axiosInstance from "./baseUrl";

export const getAnalyticsMetric = async () => {
  const response = await axiosInstance.get("/analytics/dashboard");
  return response.data;
};

export const getDetailedAnalytics = async (params: any) => {
  const response = await axiosInstance.get("/analytics/detailed", {
    params,
  });
  return response.data;
};

export const getTransactionAnalytics = async (params: any) => {
  const response = await axiosInstance.get("/analytics/filtered_transactions", {
    params,
  });
  return response.data;
};

export const getTransactionDetails = async (id: string) => {
  const response = await axiosInstance.get(`/analytics/transaction/${id}`);
  return response.data;
};
